<div class="show-div">
  <div class="edit-box" style="border:1px solid #000 ;">
    <div class="title-box" style=" width: 99.6%;
    border-bottom: 1px solid #000000 !important;">
      <span class="title-name" *ngIf="isAdd">{{"ProxyAddsingle"|translate}}</span>
      <span class="title-name" *ngIf="isEdit">{{"ProxyEditsingle"|translate}}</span>
      <em nz-icon [nzType]="'close'" class='close-btn' (click)="onClose()"></em>
    </div>
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm($event, validateForm.value)">

      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "EmployeeID" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <input nz-input formControlName="EmployeeID" (blur)="IDChange('Employee')" />

            </nz-form-control>
            <div nzPush="1">
            <span style="font-size: small;width: 120px;white-space: pre-wrap;">
              {{this.GetEmployeeEname}}
                  {{this.GetEmployeeDept}}
            </span>
          </div>
          </nz-form-item>

        </div>
       
      </div>

      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "ProxyID" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <input nz-input formControlName="ProxyID" (blur)="IDChange('Proxy')" />
            </nz-form-control>
            <div nzPush="1">
              <span style="font-size: small;width: 120px;white-space: pre-wrap;">
                {{this.GetProxyEname}}
                {{this.GetProxyDept}}
              </span>
            </div>
           
          </nz-form-item>
        </div>
      </div>

      <div nz-row *ngIf="isEdit">
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "table.PONO" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <input nz-input formControlName="PoNo" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "StartDate" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <nz-date-picker formControlName="StartDate" [nzFormat]="dateFormat"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "EndDate" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <nz-date-picker formControlName="EndDate" [nzFormat]="dateFormat"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="6">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "Remark" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="10">
              <textarea placeholder="{{'RemarkLimit'|translate}}"
              (ngModelChange)="RemarkLengthFilter($event,'Remark')" formControlName="Remark"
              style="width:100%; height:100px;overflow-y: auto;"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>



      <!-- <nz-table nzBordered nzTemplateMode nzBordered="false">
        <tbody>
          <tr>
            <td>
              <nz-form-label nzRequired>{{"EmployeeID"|translate}}</nz-form-label>
            </td>
            <td>
              <nz-form-control>
                <input nz-input formControlName="EmployeeID" (blur)="IDChange('Employee')" />
              </nz-form-control>
            </td>
            <td style="font-size: small;width: 120px;white-space: pre-wrap;">{{this.GetEmployeeEname}}
              {{this.GetEmployeeDept}}</td>
          </tr>
          <tr>
            <td>
              <nz-form-label nzRequired>{{"ProxyID"|translate}}</nz-form-label>
            </td>
            <td>
              <nz-form-control><input nz-input formControlName="ProxyID" (blur)="IDChange('Proxy')" /></nz-form-control>
            </td>
            <td style="font-size: small;width: 120px;white-space: pre-wrap;">{{this.GetProxyEname}}
              {{this.GetProxyDept}}</td>
          </tr>
          <tr class="select">
          </tr>
          <tr *ngIf="isEdit">
            <td>
              <nz-form-label>{{"table.PONO"|translate}}</nz-form-label>
            </td>
            <td>
              <nz-form-control><input nz-input formControlName="PoNo" /></nz-form-control>
            </td>
          </tr>
          <tr>
            <td>
              <nz-form-label nzRequired>{{"StartDate"|translate}}</nz-form-label>
            </td>
            <td colSpan="2">
              <nz-date-picker formControlName="StartDate" [nzFormat]="dateFormat"></nz-date-picker>
            </td>
          </tr>
          <tr>
            <td>
              <nz-form-label nzRequired>{{"EndDate"|translate}}</nz-form-label>
            </td>
            <td colSpan="2">
              <nz-date-picker formControlName="EndDate" [nzFormat]="dateFormat"></nz-date-picker>
            </td>
          </tr>
          <tr>
            <td>
              <nz-form-label>{{"Remark"|translate}}</nz-form-label>
            </td>
            <td colSpan="2"><textarea placeholder="{{'RemarkLimit'|translate}}"
                (ngModelChange)="RemarkLengthFilter($event,'Remark')" formControlName="Remark"
                style="width:100%; height:100px;overflow-y: auto;"></textarea></td>
          </tr>
        </tbody>
      </nz-table> -->

      <div nz-row style="margin-top: 10px;" class="buttonstyle">
        <div nz-col nzSpan="16" nzPush="9" style="margin-top: 15px;">

          <button nz-button nzType="default" class="cancelProxy default-button" (click)="cancelProxy()">{{'Cancel
            Proxy'|translate}}</button>
          <button nz-button nzType="default" style="height: 34px;margin-left: 45px;"
            (click)="onClose()">{{'Cancel'|translate}}</button>
          <button nz-button nzType="default" [disabled]="!validateForm.valid"
            class="margin-left-10 default-button">{{'Save'|translate}}</button>
        </div>
      </div>


    </form>
  </div>
</div>